<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/">Экспертиза промышленной безопасности</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expertkltp">Проведение экспертизы промышленной безопасности всех объектов и документации КЛТП</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Проведение экспертизы промышленной безопасности всех объектов и документации КЛ / ТП
    </h1>
    <p>Проведем <strong>экспертизу промышленной безопасности</strong> проектов <strong>консервации, ликвидацияи или технического перевооружение</strong> ОПО, <strong>технических устройств</strong>, <strong>зданий и сооружений</strong>, относящихся к опасным производственным объектам.</p>

  </div>
  <app-recall-form heading="Получить консультацию по своему объекту"></app-recall-form>
  <p><strong>Проведение экспертизы промышленной безопасности:</strong></p>

  <ul class="marked ml-50">
    <li>Документации по консервации, техническому перевооружению и ликвидации ОПО (КЛТП);</li>
    <li>Зданий, сооружений ОПО;</li>
    <li>Кранов и грузоподъемных механизмов;</li>
    <li>Трубопроводов, газопроводов и теплосетей;</li>
    <li>Сосудов, работающих под давлениеми резервуаров РВС, РГС;</li>
    <li>Технических устройств.</li>
  </ul>

  <p class="mt-4"><strong>Разработка документации:</strong></p>

  <ul class="marked ml-50">
    <li><a href="https://www.fsetan.ru/proekt-likvidatsii-i-konservatsii-opo/konservatsiya/">Консервация;</a></li>
    <li><a href="https://www.fsetan.ru/proekt-likvidatsii-i-konservatsii-opo/likvidatsiya/">Ликвидация;</a></li>
    <li><a href="https://www.fsetan.ru/tehnicheskoe-perevooruzhenie-opo/">Техническое перевооружение.</a></li>
  </ul>

  <p class="mt-4"><strong>Подготовка исполнительной и нормативной документации;</strong></p>

  <p class="mt-4"><strong>Постановка на учет:</strong></p>

  <ul class="marked ml-50">
    <li>Оборудование, работающее под избыточным давлением;</li>
    <li>Грузоподъемные механизмы.</li>
  </ul>

  <p><strong>Регистрация ОПО, внесение требуемых изменений в госреестр &laquo;под ключ&raquo;, в том числе исключение ОПО из реестра;</strong></p>

  <p class="mt-4"><strong>Лицензирование ОПО;</strong></p>

  <p class="mt-4"><strong>Методическое сопровождение документов в территориальных управлениях Федеральной службы по экологическому, технологическому и атомному надзору (Ростехнадзор).</strong></p>
  <app-atomka-calc></app-atomka-calc>
  <div class="mt-5 row">
    <div class="col">
      <img src="assets/img_28.png" height="880" alt="" style="width: 100%; max-height: 880px;">
      <p class="text-center">Лицензия ООО "Протос Экспертиза"</p>
    </div>
    <div class="col">
      <img src="assets/img_29.png" height="880" style="width: 100%; max-height: 880px;" alt="">
      <p class="text-center">Свидетельство об аттестации ЛНК</p>

    </div>
  </div>
  <p class="mt-5"><strong>Порядок проведения экспертизы технической безопасности:</strong></p>

  <ol class="marked ml-50">
    <li><strong>Консультация.</strong></li>
    <li><strong>Заключение договора </strong>на проведение экспертизы.</li>
    <li><strong>Сбор и анализ </strong>всей<strong> документации</strong>, необходимой для проведения и организации работ.</li>
    <li><strong>Проведение экспертизы</strong> промышленной безопасности.</li>
    <li><strong>Предоставление заключения</strong> экспертизы промышленной безопасности.</li>
    <li><strong>Внесение заключения</strong> экспертизы <strong>в соответствующий государственный реестр.</strong></li>
  </ol>

  <p>Подробнее об этапах проведения и объектах, подлежащих экспертизе промышленной безопасности <a href="https://www.fsetan.ru/expprombez/">тут</a>.&nbsp;</p>
  <app-recall-form heading="Напишите ваш вопрос, и наши специалисты вас проконсультируют"></app-recall-form>
  <app-reviews-block class="w-100"></app-reviews-block>

</div><app-footer></app-footer>
